export default {
  "kFactor.title": "K-Factor",
  "kFactor.column.no": "#NO",
  "kFactor.column.statisticsTime": "Date",
  "kFactor.column.registerNum": "Total Registrations",
  "kFactor.column.inviteNum": "Invited Registrations",
  "kFactor.column.inviteActiveNum": "Activated Count",
  "kFactor.column.inviteAvg": "i (Average Invitations)",
  "kFactor.column.activeRatio": "c (Activation Rate)",
  "kFactor.search.statisticsTime": "Date",
};